
///<summary>
/// This file is used to redirect users with old pages in their browser to the new pages.
/// This is reuired when the page structure is changed and the old pages are no longer valid leaving users stuck on a blank page.
/// The file can be deleted a week after all sites are patched with the new joblist patch.
///</summary>


//Export item
const branch =  [
  {
    meta: { overrides: { sidebar: false } },
    path: "list/my/:jobId?",
    redirect: { name: "JobList", params: { filter: "my" } }
  },
  {
    meta: { overrides: { sidebar: false } },
    path: "list/partsjobs/:jobId?",
    redirect: { name: "JobList", params: { filter: "parts" } }
  },
  {
    meta: { overrides: { sidebar: false } },
    path: ":jobId?/list/status/:statusId?/substatus/filter/:filterId?",
    redirect: { path: "/job/list/status-:statusId-0" }
   },
  {
    meta: { overrides: { sidebar: false } },
    path: ":jobId?/list/status/:statusId?/substatus/:subStatusId/filter/:filterId?",
    redirect: { path: "/job/list/status-:statusId-:subStatusId" }
   },

  {
    meta: { overrides: { sidebar: false } },
    path: 'newjob',
    redirect: { name: 'NewJobStart', params: { filter: "my" } },
    children: [
      {
        path: "start/:jobId?",
        redirect: { name: 'NewJobStart', params: { filter: "my" } }
      },
      {
        path: "overview",
        redirect: { name: 'NewJobStart', params: { filter: "my" } }
      },
    ]
  },

  {
    meta: { overrides: { sidebar: false } },
    path: "view/:jobId",
    redirect: { path: "/job/list/my/view/:jobId/general" },
    children: [
      {
        path: "general",
        redirect: { path: "/job/list/my/view/:jobId/general" }
      },
      {
        path: "planning/:appointmentId?",
        redirect: { path: "/job/list/my/view/:jobId/planning/:appointmentId?" }
      },
      {
        path: "checklists",
        redirect: { path: "/job/list/my/view/:jobId/checklists" }
      },
      {
        path: "logg",
        redirect: { path: "/job/list/my/view/:jobId/logg" }
      },
      {
        path: "resources",
        redirect: { path: "/job/list/my/view/:jobId/resources" }
      },
      {
        path: "parts",
        redirect: { path: "/job/list/my/view/:jobId/parts" },
        children: [
          {
            path: "editpart/:machineJobId/:partId?",
            redirect: { path: "/job/list/my/view/:jobId/parts/editpart/:machineJobId/:partId?" }
          },
          {
            path:"edittime/:machineJobId/:timeId?",
            redirect: { path: "/job/list/my/view/:jobId/parts/edittime/:machineJobId/:timeId?" }
          },
          {
            path:"addpart/:machineJobId",
            redirect: { path: "/job/list/my/view/:jobId/parts/addpart/:machineJobId" }
          },
          {
            path: "addtime/:machineJobId",
            redirect: { path: "/job/list/my/view/:jobId/parts/addtime/:machineJobId" }
          }
        ]
      },
      {
        path: "invoice",
        redirect: { path: "/job/list/my/view/:jobId/invoice" }
      },
    ]
  },
];

export default branch;
